import Bullet, { BulletContainer } from './Bullet';
import MostPopularTitle from './MostPopularTitle';
import { SEARCH_PARAMS } from '../constants/searchParamNames';
import { useSearchParams } from 'react-router-dom';

interface Props {
  setActiveSection: (activeSection: string) => void;
  activeSection: string;
}

const HomepageSectionsNavigation: React.FC<Props> = ({ setActiveSection, activeSection }) => {
  const [searchParams] = useSearchParams();

  const location = searchParams.get(SEARCH_PARAMS.LOCATION) ?? 'Cela Srbija';

  const hasDefinitiveLocation = () => {
    return location?.split(',').length === 1;
  };

  return (
    <BulletContainer>
      <Bullet children="Aktuelno" onClick={() => setActiveSection('current')} isActive={activeSection === 'current'} />
      <Bullet
        onClick={() => setActiveSection('popular')}
        children={hasDefinitiveLocation() ? <MostPopularTitle forLocation={location as string} /> : 'Najpopularnije'}
        isActive={activeSection === 'popular'}
      />
      <Bullet
        onClick={() => setActiveSection('discount')}
        children="Najveći popusti"
        isActive={activeSection === 'discount'}
      />
      <Bullet
        onClick={() => setActiveSection('newest')}
        children="Najnovije ponude"
        isActive={activeSection === 'newest'}
      />
    </BulletContainer>
  );
};

export default HomepageSectionsNavigation;
